<template>
  <div >
    <div class="row justify-content-center">
      <div class="col-10 my-4">
        <div class="row justify-content-center lead">
          <span v-if="usesQ4">{{
              buildTitle(data.title, user)
          }}</span><span v-else>
            {{ data.title }}
          </span>
        </div>


        <div class="matrix-list row mt-4">
            <div class="col">
              <div class = "row mt-4" v-for="(question, key) in questionRows" :key="key">
                <div class="col">
                <div class="row text-left"><p>{{question.q}}</p></div>
                <div class="row" v-for="(response,index) in questionCols" :key="index">
                  <div class="col ml-2">
                    <input v-model="answer[key]" @change="onValueChange" :name="'ans' + key + index+'list'"
                        class="btn-check ml-2" type="radio" v-bind:id="'ans' + key + index + 'list'" :value="index"
                        aria-label="..."
                         /><span class="small ml-2">{{response}}</span>
                    <!-- <div class="row justify-content-center" v-for="(question,key) in questionRows" :key="key">
                      
                    </div> -->
                  
                  </div>
                </div>
                </div>
              </div>
              <br>
            </div>
            
        </div>

        <div class=matrix>
        <div class="row mt-4">
          <div class="col-3" v-if="questionCols.length<8"></div>
          <div class="col-3" v-else></div>
          <div class="col" v-if="questionCols.length==3">
            <div class="row justify-content-center">
              <div class="col-3" v-for="(response,index) in questionCols" :key="index">
                  <span class="small">{{response}}</span>
              </div>
            </div>
          </div>
          <div class="col" v-else-if="questionCols.length<8">
            <div class="row">
              <div class="col" v-for="(response,index) in questionCols" :key="index">
                  <span class="small">{{response}} </span>
              </div>
            </div>
          </div>
          <div class="col" v-else>
            <div class="row ">
              <div class="col" v-for="(response,index) in questionCols" :key="index">
                  <span class="small">{{response}} </span>
              </div>
            </div>
          </div>
        </div>

        
        <div class="row mt-4" v-for="(question, key) in questionRows" :key="key">
          <div class="col-3">
            <span class="small">{{ question.q }} </span>
          </div>
          <div class="col" v-if="questionCols.length==3">
           
                  <div  class="row justify-content-center">
                    <div class="col-3" v-for="(response, index) in question.a" :key="index">
                      
                      <input v-model="answer[key]" @change="onValueChange" :name="'ans' + key + index"
                        type="radio" id="blankRadio1" :value="index" 
                        aria-label="..." />
                      
                      
                    </div>
                  </div>
                
          </div>
          <div class=" col" v-else-if="questionCols.length>6">
           
                  <div  class="row">
                    <div class="col" v-for="(response, index) in question.a" :key="index">
                      
                      <input v-model="answer[key]" @change="onValueChange" :name="'ans' + key + index"
                        type="radio" id="blankRadio1" :value="index" 
                        aria-label="..." />
                      
                      
                    </div>
                  </div>
                
          </div>
        </div>
        </div>
        <p v-if="inputError===true" class="text-danger small mt-4 text-center">Please select an answer for every category</p>

      </div>
    </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div @click="previous()" class="btn btn-small nsc-cta mx-4 my-2">
      Previous
      </div>
      <div @click="validateAnswer" class="btn btn-small nsc-cta blue mx-4 my-2">
        Next
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MatrixQuestion",
  props: ["data", "nextQ", "user", "prevQ", "answers"],
  emits: ["nextQuestion","previousQuestion"],
  data() {
    return {
      inputError: null,
      questionRows: this.data.responses.questions,
      questionCols: this.data.responses.options,
      usesQ4: this.data.usesQ4 ? true : false,
      answer: {}
    };
  },
  methods: {
    buildTitle(arr, user) {
      return `${arr[0]} ${user.company} ${user.subsector} ${arr[1]}`;
    },
    onValueChange() {
      // console.log(this.answer)
      const keys = Object.keys(this.answer)
      const keys2 = Object.keys(this.data.responses.questions)
      if (keys.length == keys2.length) {
        // console.log('HERE')
        this.inputError = false
        return
      }
    },
    validateAnswer() {
      const keys = Object.keys(this.answer)
      const keys2 = Object.keys(this.data.responses.questions)

      if (keys.length < keys2.length) {
        // console.log('here')
        this.inputError = true
        // console.log(this.inputError)
        return
      } else {
        this.$emit('nextQuestion', this.nextQ, this.answer)
      }
    },
    previous(){
      this.$emit('previousQuestion', this.prevQ, this.answer)
    }
  },
  mounted(){
    // console.log(this.answers)
    for(let key in this.answers) this.answer[key] = this.answers[key];
  }
};
</script>